export const pcard_theme_configuration = {
  root: {
    background: "#FFFFFF",
    color: "unset",
    shadow: "0px 6px 6px 0px rgba(0, 0, 0, 0.0588235294)",
  },
  colorScheme: {
    light: {
      background: "#FFFFFF",
    },
    dark: {
      background: "#010622",
    },
  },
};
